import { render, staticRenderFns } from "./object-card-video-archive.vue?vue&type=template&id=161b7dd2"
import script from "./object-card-video-archive.vue?vue&type=script&lang=js"
export * from "./object-card-video-archive.vue?vue&type=script&lang=js"
import style0 from "./object-card-video-archive.vue?vue&type=style&index=0&id=161b7dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports